import React from 'react';
import { getGamePackImageSrc } from '../utils/gamePackImages';
import { findPackById, formatCreditCost, formatStorePrice, getPackDescription, getPackId, getPackName } from './packSelectorUtils';

const GamePackSelector = ({
  gamePacks,
  selectedGamePack,
  onSelectGamePack,
  onOpenLockedGame,
  disabled,
  conversationStarted,
}) => {
  if (conversationStarted) {
    const selectedGamePackDetails = findPackById(gamePacks, selectedGamePack);
    const displayText = selectedGamePackDetails
      ? getPackName(selectedGamePackDetails)
      : selectedGamePack;

    return (
      <div className="cq-pack-display">
        <p className="cq-pack-display__label">Game</p>
        <p className="cq-pack-display__name">{displayText}</p>
      </div>
    );
  }

  return (
    <div className="cq-game-grid" role="listbox" aria-label="Game selector">
      {(gamePacks || []).map((pack) => {
        const packId = getPackId(pack);
        const isSelected = selectedGamePack === packId;
        const isLocked = Boolean(pack.is_locked);
        const badges = [];

        if (isSelected) {
          badges.push('Selected');
        }
        if (pack.is_owned && !isSelected) {
          badges.push('Owned');
        }
        if (isLocked) {
          badges.push(formatStorePrice(pack.price_usd) || 'Locked');
        }

        return (
          <button
            key={packId}
            type="button"
            className={`cq-game-card${isSelected ? ' is-selected' : ''}${isLocked ? ' is-locked' : ''}`}
            onClick={() => (isLocked ? onOpenLockedGame?.(pack) : onSelectGamePack?.(packId))}
            disabled={disabled}
            aria-pressed={isSelected}
          >
            <span className="cq-game-card__art-wrap" aria-hidden="true">
              <img
                className="cq-game-card__art"
                src={getGamePackImageSrc(pack.image_filename, pack.host_image_filename)}
                alt=""
              />
            </span>

            <span className="cq-game-card__body">
              <span className="cq-game-card__topline">
                <span className="cq-game-card__title">{getPackName(pack)}</span>
                <span className="cq-badge-row cq-badge-row--game">
                  {badges.map((badge) => (
                    <span
                      key={`${packId}-${badge}`}
                      className={`cq-status-badge${badge === 'Selected' ? ' is-selected' : ''}${isLocked && badge !== 'Selected' ? ' is-locked' : ''}`}
                    >
                      {badge}
                    </span>
                  ))}
                </span>
              </span>

              <span className="cq-game-card__description">
                {pack.display_description || getPackDescription(pack) || 'Fast laughs. Zero chill.'}
              </span>

              <span className="cq-game-card__meta">
                <span>{pack.play_style_label || 'Group'}</span>
                <span className="cq-game-card__cost">{formatCreditCost(pack.session_credit_cost) || '0 Credits to Play'}</span>
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default GamePackSelector;
